/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page }) {
    const url = page ? `${this.url}?page=${page}` : this.url;
    return axios.get(url);
  }

  find(id) {
    return axios.get(`${this.url}/find_audit`, { params: { id } });
  }
}

export default new AuditLogs();
